import React from 'react';

const FuturaSmileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <defs>
      <path id="futura-spark" d="M12 2 L13.5 9 L12 11 L10.5 9 Z" />
    </defs>
    <use href="#futura-spark" />
    <use href="#futura-spark" transform="rotate(45 12 12)" />
    <use href="#futura-spark" transform="rotate(90 12 12)" />
    <use href="#futura-spark" transform="rotate(135 12 12)" />
    <use href="#futura-spark" transform="rotate(180 12 12)" />
    <use href="#futura-spark" transform="rotate(225 12 12)" />
    <use href="#futura-spark" transform="rotate(270 12 12)" />
    <use href="#futura-spark" transform="rotate(315 12 12)" />
  </svg>
);

export default FuturaSmileIcon;
